import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["error"]

  connect() {
    this.validate()
  }

  validate() {
    const textarea = this.element.querySelector('textarea')
    if (!textarea) return

    textarea.addEventListener('input', () => {
      this.validateJSON(textarea.value)
    })
  }

  validateJSON(jsonString) {
    const errorTarget = this.errorTarget
    
    if (!jsonString.trim()) {
      this.hideError()
      return true
    }

    try {
      JSON.parse(jsonString)
      this.hideError()
      return true
    } catch (e) {
      this.showError(`Ungültiges JSON: ${e.message}`)
      return false
    }
  }

  showError(message) {
    const errorTarget = this.errorTarget
    errorTarget.textContent = message
    errorTarget.classList.remove('hidden')
  }

  hideError() {
    const errorTarget = this.errorTarget
    errorTarget.classList.add('hidden')
  }
} 